module.exports = __webpack_public_path__ + "img/wave.0748ca57.svg";